import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';

// ?preferred_variant=GOLDEN_EXP_V4:control
// ?preferred_variant=GOLDEN_EXP_V4:variant_1
// ?preferred_variant=GOLDEN_EXP_V4:variant_2
// ?preferred_variant=GOLDEN_EXP_V4:variant_3
// ?preferred_variant=GOLDEN_EXP_V4:variant_4
// ?preferred_variant=GOLDEN_EXP_V4:variant_5
// ?preferred_variant=GOLDEN_EXP_V4:variant_6

// ?remove_preferred_experiment=GOLDEN_EXP_V4

export const BuyboxGoldenExp = 'GOLDEN_EXP_V4' as const;

export const BuyboxGoldenExpVariants = {
	CONTROL: 'control',
	VARIANT_1: 'variant_1',
	VARIANT_2: 'variant_2',
	VARIANT_3: 'variant_3',
	VARIANT_4: 'variant_4',
	VARIANT_5: 'variant_5',
	VARIANT_6: 'variant_6',
} as const;

export const VARIANTS_DIC: Record<string, string> = {
	control: 'control',
	variant_1: 'v1',
	variant_2: 'v2',
	variant_3: 'v3',
	variant_4: 'v4',
	variant_5: 'v5',
	variant_6: 'v6',
};

export function getGolgenExpTagInformation(variant: string, country: string) {
	const mVariant = VARIANTS_DIC[variant];
	const mCountry = country.toLowerCase();
	const mNumber = '20'; // mCountry === 'us' ? '20' : '21';
	return {
		variant: mVariant,
		country: mCountry,
		number: mNumber,
	};
}

export type BuyboxGoldenExpVariants = ToVariants<typeof BuyboxGoldenExpVariants>;

export default generate(BuyboxGoldenExp, BuyboxGoldenExpVariants);
